// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__3s7Mj","styledRow__header":"styles_styledRow__header__2xId3","styledRow__footer":"styles_styledRow__footer__32sRC"};